import { render, staticRenderFns } from "./MSALLogin.vue?vue&type=template&id=5b3826f7&"
import script from "./MSALLogin.vue?vue&type=script&lang=js&"
export * from "./MSALLogin.vue?vue&type=script&lang=js&"
import style0 from "./MSALLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports